module.exports = __webpack_public_path__ + "static/media/quote-left.48a7b6b7.svg";